import React, { Fragment, useState } from 'react';
import { userImg } from '../../lib/constants';
import { useFetch } from '../../lib/useFetch';
import RecordsTable from './recordsTable';
import PaginationBar from '../../components/pagination';
const userHeaders = ["Image", "Username", "First", "Last", "email", "Phone"];

const mapResponseData = (data) => {
  const getTrimmedObj = (obj) => {
    let trimmedObj = {}
    trimmedObj['id'] = obj['_id'];
    trimmedObj['image'] = obj['photo'] || userImg;
    trimmedObj['username'] = obj['username'];
    trimmedObj['firstname'] = obj['firstName'];
    trimmedObj['lastnname'] = obj['lastName'];
    trimmedObj['email'] = obj['email'];
    trimmedObj['phone'] = obj['phone'];
    trimmedObj['isVerified'] = obj['verified']
    return trimmedObj;
  }
  if (data) {
    return data.map(obj => getTrimmedObj(obj));
  }
  return [];
}

const AdminUsers = ({ openMainModal, location }) => {
  const getRole = () => {
    const paths = {
      '/admins/Administrator': `role=Administrator`,
      '/admins/SuperAdmin': `role=SuperAdmin`,
      '/admins/Operator': `role=Operator`,
    }
    return paths[location.pathname] || ''
  }
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [reload, toggleReload] = useState(false)

  const onSearch = (term) => {
    setSearchQuery(term);
    setPage(1);
  };

  const searchParam = searchQuery ? `&search=${encodeURIComponent(searchQuery)}` : '';
  const { data, loading, totalCount } = useFetch(`admins?page=${page}&${getRole()}${searchParam}`, reload);

  return (
    <Fragment>
      <RecordsTable
        loading={loading}
        headers={userHeaders}
        records={mapResponseData(data)}
        openMainModal={openMainModal}
        reload={()=>toggleReload(r=> !r)}
        searchQuery={searchQuery}
        onSearch={onSearch}
      />
      <PaginationBar page={page} totalCount={totalCount} setPage={setPage} />
    </Fragment>
  );
}

export default AdminUsers;
